<template>
  <div>
    <div class="grid grid-cols-2 gap-7 mt-7">
      <FormField id="name" label="Nom" v-model="name" />
      <FormField id="businessName" label="Raison sociale" v-model="businessName" />
      <FormField id="billingAddress" label="Adresse de facturation" v-model="billingAddress" />
      <FormField v-if="showIban" id="iban" label="IBAN" v-model="iban" />
      <div class="col-span-2">
        <label class="block text-sm font-medium text-gray-700 mb-1">Magasins</label>
        <div class="relative">
          <div v-if="selectedStoresCount > 0" class="absolute -top-2 -right-2 z-10">
            <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-primary text-white">
              {{ selectedStoresCount }}
            </span>
          </div>
          <MultiSelectSearch
            :search-groups="searchGroups"
            placeholder="Rechercher un magasin..."
            input-id="billing-entity-stores-search"
            :min-search-length="0"
            :debounce-delay="300"
            :show-component="true"
            :initial-selections="initialSelections"
            @update-selections="handleUpdateSelections"
            @search="handleSearch"
            @toggle-item="handleToggleItem"
            @clear-results="handleClearResults"
          />
        </div>
      </div>
    </div>
    <div class="text-center mt-7 mb-5">
      <GenericButton @click="$emit('submit')">Enregistrer</GenericButton>
    </div>
  </div>
</template>

<script>
import { FormField, GenericButton, MultiSelectSearch } from "@estaly/ui";

export default {
  components: {
    FormField,
    GenericButton,
    MultiSelectSearch,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    stores: {
      type: Array,
      default: () => [],
    },
    showIban: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "submit"],
  data() {
    return {
      name: this.modelValue?.name || null,
      businessName: this.modelValue?.businessName || null,
      billingAddress: this.modelValue?.billingAddress || null,
      iban: this.modelValue?.iban || null,
      selectedStores: [],
      filteredStores: null,
    };
  },
  computed: {
    availableStores() {
      return this.filteredStores ?? this.stores;
    },
    searchGroups() {
      return [
        {
          key: "stores",
          label: "Magasins",
          items: this.availableStores,
          getDisplayName: (store) =>
            `${store.salesChannel} (${store.ownershipType ? this.$t(`store.ownership_type.${store.ownershipType}`) : "-"})`,
          isSelected: (storeId) => this.storeIds.includes(storeId),
        },
      ];
    },
    initialSelections() {
      return { stores: this.selectedStores };
    },
    selectedStoresCount() {
      return this.selectedStores.length;
    },
    storeIds() {
      return this.selectedStores.map((store) => store.id);
    },
  },
  mounted() {
    const initialStoreIds = this.modelValue?.storeIds || [];
    this.selectedStores = this.stores.filter((store) => initialStoreIds.includes(store.id));
  },
  watch: {
    name(newValue) {
      this.$emit("update:modelValue", { ...this.modelValue, name: newValue });
    },
    businessName(newValue) {
      this.$emit("update:modelValue", { ...this.modelValue, businessName: newValue });
    },
    billingAddress(newValue) {
      this.$emit("update:modelValue", { ...this.modelValue, billingAddress: newValue });
    },
    iban(newValue) {
      this.$emit("update:modelValue", { ...this.modelValue, iban: newValue });
    },
    selectedStores() {
      this.$emit("update:modelValue", { ...this.modelValue, storeIds: this.storeIds });
    },
  },
  methods: {
    handleSearch(keywords) {
      if (!keywords) {
        this.filteredStores = null;
        return;
      }
      const lower = keywords.toLowerCase();
      this.filteredStores = this.stores.filter((store) => store.salesChannel?.toLowerCase().includes(lower));
    },
    handleToggleItem({ item, groupKey }) {
      if (groupKey !== "stores") return;
      const index = this.selectedStores.findIndex((store) => store.id === item.id);
      if (index >= 0) {
        this.selectedStores = this.selectedStores.filter((store) => store.id !== item.id);
      } else {
        this.selectedStores = [...this.selectedStores, item];
      }
    },
    handleUpdateSelections(selections) {
      this.selectedStores = selections.stores || [];
    },
    handleClearResults() {
      this.filteredStores = null;
    },
  },
};
</script>
